import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';

import manualReducer from './reducers';

const WebTestingContainer = () => import(/* webpackChunkName: "manual-web-testing" */ './containers/configurator/WebTestingContainer');
const AppTestingContainer = () => import(/* webpackChunkName: "manual-app-testing" */ './containers/configurator/AppTestingContainer');
const testProxyImport = () => import(/* webpackChunkName: "manual-test" */ './containers/sessionVirtual/TestProxyContainer');

const ManualRoutes = () => (
  <LoginRequiredContainer>
    <Switch>
      <BundleRoute
        load={testProxyImport}
        path="/live/test_proxy/:jobId"
      />
      <BundleRoute
        load={WebTestingContainer}
        path="/live/web-testing"
      />
      <BundleRoute
        load={AppTestingContainer}
        path="/live/app-testing"
      />
      <Redirect to="/live/web-testing" />
    </Switch>
  </LoginRequiredContainer>
);

export default dynamic(
  'apps.manual', attachReducer(manualReducer),
)(ManualRoutes);
